import React, { createContext, useContext, useState } from 'react';
import { useQuickQuoteApi } from 'hooks/useQuickQuoteApi';
import PropTypes from 'prop-types';
import { formatLocation } from '../utils/utils';

const PageQuickQuoteContext = createContext();

export const usePageQuickQuoteContext = () => useContext(PageQuickQuoteContext);

export const PageQuickQuoteProvider = ({ children, allowedLocations }) => {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [product, setProduct] = useState('');
  const [shippingData, setShippingData] = useState('');
  const [shipParams, setShipParams] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getQuickQuote, loading } = useQuickQuoteApi();

  const handleFromSelect = (item) => setFrom(item);
  const handleToSelect = (item) => setTo(item);
  const handleProductSelect = (item) => setProduct(item);

  const locationTypeMap = {
    'Club': (location) => ({ facility_id: location.id, display: formatLocation(location) }),
    'GooglePlace': (location) => ({ google_place_id: location._id, display: location.formatted_address }),
    'SkiResort': (location) => ({ facility_id: location._id, display: location.formatted_address }),
    'StoredShipPoint': (location) => ({ ship_point_id: location._id, display: location.formatted_address }),
    'AddressPoint': (location) => ({ address_point_id: location._id, display: location.formatted_address }),
    'Default': (location) => ({ address_point_id: location._id, display: location.formatted_address }),
  };

  const getLocation = (location) => {
    console.log(location)
    console.log('type')
    console.log(locationTypeMap[location.type])
    return (locationTypeMap[location.type] || locationTypeMap['Default'])(location);
  };

  const brand = window.gon.current_brand;

  const handleSubmit = async () => {
    setIsModalOpen(true);

    try {
      const origination = getLocation(from);
      const destination = getLocation(to);
      const request = {
        brand,
        product_id: product.id,
        origination,
        destination,
      };
      console.log(request)
      const { data } = await getQuickQuote(request);
      setShippingData(data);
      console.log(data)
      setShipParams(data.ship_params);
    } catch (error) {
      console.error('Failed to fetch quick quote data:', error);
    }
  };

  const value = {
    from,
    to,
    product,
    shippingData,
    shipParams,
    isModalOpen,
    setShippingData,
    setIsModalOpen,
    handleFromSelect,
    handleToSelect,
    handleProductSelect,
    handleSubmit,
    loading,
    allowedLocations,
    brand,
    activeProducts: window.gon.active_products,
    partnerId: window.gon.partner_id || '',
  };

  return (
    <PageQuickQuoteContext.Provider value={value}>
      {children}
    </PageQuickQuoteContext.Provider>
  );
};

PageQuickQuoteProvider.propTypes = {
  children: PropTypes.node.isRequired,
  allowedLocations: PropTypes.array,
};

